<template>
  <div class="edit-profile-container">
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    
    <v-snackbar v-model="showSnackBar" color="#3EA56E" right :timeout="timeout" class="mt-12">
      <div class="d-flex align-center">
        <v-icon color="white" class="mr-2">mdi-alert-circle-outline</v-icon>
        <span class="font-weight-medium">{{ msg }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="showSnackBar = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <div class="d-flex align-center mb-8">
      <v-icon color="#3EA56E" class="mr-3">mdi-account-edit-outline</v-icon>
      <h2 class="section-title">Edit Your Profile</h2>
    </div>

    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col cols="12" sm="6" class="mb-2">
          <div class="input-wrapper">
            <label class="input-label">First Name</label>
            <v-text-field
              v-model="firstname"
              :rules="[rules.required]"
              outlined
              dense
              class="custom-field"
              placeholder="Enter your first name"
            ></v-text-field>
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="mb-2">
          <div class="input-wrapper">
            <label class="input-label">Last Name</label>
            <v-text-field
              v-model="lastname"
              :rules="[rules.required]"
              outlined
              dense
              class="custom-field"
              placeholder="Enter your last name"
            ></v-text-field>
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="mb-2">
          <div class="input-wrapper">
            <label class="input-label">Phone Number</label>
            <v-text-field
              v-model="phone"
              :rules="[rules.required]"
              outlined
              dense
              class="custom-field"
              placeholder="Enter phone number"
              prefix="+91"
            ></v-text-field>
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="mb-2">
          <div class="input-wrapper">
            <label class="input-label">Email ID</label>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              outlined
              dense
              class="custom-field"
              placeholder="Enter email address"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>

      <v-layout wrap class="mt-8 justify-start">
        <v-flex xs12 sm6 md4>
          <v-btn
            block
            height="48"
            color="#3EA56E"
            dark
            class="update-btn elevation-0"
            @click="editProfile"
          >
            UPDATE PROFILE
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-sm-4 mt-4 mt-sm-0">
          <v-btn
            block
            height="48"
            outlined
            color="#64748b"
            class="cancel-btn text-none"
            to="/Profile"
          >
            Cancel
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      valid: true,
      timeout: 5000,
      msg: null,

      userId: null,
      firstname: null,
      lastname: null,
      phone: null,
      email: null,

      rules: {
        required: (value) => !!value || "Required.",
      },
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.userId = response.data.data._id;
            this.firstname = response.data.data.firstname;
            this.lastname = response.data.data.lastname;
            this.phone = response.data.data.phone;
            this.email = response.data.data.email;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.error("Error fetching profile:", err);
        });
    },
    editProfile() {
      if (this.$refs.form.validate()) {
        const userData = {
          id: this.userId,
          firstname: this.firstname,
          lastname: this.lastname,
          phone: this.phone,
          email: this.email,
        };
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/user/Edit",
          data: userData,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status) {
              this.$store.commit("userData", response.data.data);
              this.$router.push("/Profile");
            } else {
              this.msg = response.data.msg || "Update failed";
              this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.error("Error updating profile:", err);
          });
      }
    },
  },
};
</script>

<style scoped>
.edit-profile-container {
  text-align: left;
}

.section-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 20px;
  color: #1a202c;
  margin: 0;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
}

.input-label {
  font-family: "ibmsemibold", sans-serif;
  font-size: 13px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.update-btn {
  font-family: "ibmsemibold", sans-serif;
  font-size: 16px;
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.update-btn:hover {
  transform: translateY(-2px);
}

.cancel-btn {
  border-radius: 8px;
  font-family: "ibmsemibold", sans-serif;
}

/* Custom styles for Vuetify inputs */
.custom-field >>> .v-input__slot {
  border-radius: 10px !important;
}

.custom-field >>> .v-label {
  font-family: "ibmregular", sans-serif;
  font-size: 14px;
}

.custom-field >>> input {
  font-family: "ibmregular", sans-serif;
  font-size: 15px;
  color: #1e293b;
}

@media (max-width: 600px) {
  .section-title {
    font-size: 18px;
  }
}
</style>